import React, { ReactNode } from "react";
import Navbar from "./navbar";
import "react-toastify/dist/ReactToastify.css";

interface LayoutProps {
  children: ReactNode;
}

const LayoutWithNavbar: React.FC<LayoutProps> = ({ children }) => {
  return (
    <>
      <Navbar />
      {children}
    </>
  );
};

export default LayoutWithNavbar;
